import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_helpers";

export function ScrollTop() {
  return (
    <div id="kt_scrolltop" className="scrolltop btn btn-icon btn-dark btn-hover-light">
      <span className="svg-icon svg-icon-md svg-icon-primary">
        <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Up-2.svg")}></SVG>
      </span>{" "}
    </div>
  );
}
